import { LocalizationProvider, TabContext, TabList, TabPanel } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import {
  Badge,
  Box,
  Button,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Typography,
} from "@mui/material";
import { useState } from "react";
import api from "../../../../components/services/api";
import { useEffect } from "react";
import { useParams } from "react-router";
import Swal from "sweetalert2";
import Survey from "../../../Ship/containers/Editinbound/Survey";
import Zone from "../../../Ship/containers/Editinbound/Zone";
import PlanZone from "../../../Ship/containers/Editinbound/PlanZone";
export default function EditInboundtruck() {
  let { id } = useParams();
  const data_params = { id: id };
  const [statusSelect_data, setStatusSelect_data] = useState("");
  const [containerdata, setContainer] = useState([]);
  const [saleOrderNo, setSaleOrderNo] = useState();
  const [statusSO_data, setStatusSo_data] = useState([]);
  // const [voy_no_select, setVoySelect] = useState([]);

  const [value, setValue] = useState("2");
  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };

  const getdata = async () => {
    try {
      const data = await api.get(`api/containermovement/inbound/detail/${id}`);
      const res =data?.data
      setContainer(res)
    } catch (e) {
      console.log(e);
    }
  };
  console.log(containerdata)
  useEffect(() => {
    getdata();
  }, []);
  //fetch SaleOrder Data
  // const getSaleOrder_Data = async () => {
  //   try {
  //     const data = await api
  //       .post("api/saleorder/detail", data_params)
  //       .then((response) => {
  //         [].concat(response.data).map((res) => {
  //           console.log(res);

  //           setSaleOrderData(res);
  //           // setMT_CNTR_AT_CY_STL_DATA(res.mt);

  //           // setPlanData(res.plan);
  //           // setLadenData(res.laden);
  //           // GetQuotation(res.CustomerId);
  //           // setVoySelect(res.PickupVoyageNo);
  //           setStatusSelect_data(res.StatusSO);

  //           // getContainerList_Data(res.SoId);

  //           // if (res.FreePoLDem.length != "" || res.FreePoLDet.length != "") {
  //           //   setComDisable(true);
  //           // }
  //           // if (res.FreePoLCom.length != "") {
  //           //   setDetDemDisable(true);
  //           // }
  //         });
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };
  //fetch Group

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs>
              <Typography
                className="textcolordarkblue"
                variant="h5"
                component="h1"
              >
                Inbound
              </Typography>
              {/* <Typography className="textcolorgreen">
                
              </Typography> */}
            </Grid>
          </Grid>

          <Box
            sx={{
              display: "flex",
              marginBottom: "10px",
              width: 200,
              flexDirection: "row",
            }}
          >
            <Typography className="textcolorBule">Truck</Typography>
            <Typography>
              <span>&nbsp;/ Detail Inbound</span>
            </Typography>
          </Box>
        </div>

        <TabContext value={value}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              marginTop: "10px",
            }}
          >
            <TabList
              variant="scrollable"
              scrollButtons="auto"
              onChange={handleChangeTab}
              TabIndicatorProps={{
                style: { backgroundColor: "transparent" },
              }}
              sx={{
                overflow: "visible",
                "& .MuiTabs-scroller": { overflow: "visible !important" },
              }}
            >
              {/* <Tab
                sx={{
                  "&.Mui-selected": {
                    background: "#80C340",
                    color: "white",
                    borderTopLeftRadius: "15px",
                    borderTopRightRadius: "15px",
                  },
                  overflow: "visible",
                  "& .MuiTabs-scroller": { overflow: "visible !important" },
                }}
                label={
                  // <Badge badgeContent={4} color="error" sx={{ "& .MuiBadge-badge": { top: '-10px' } }}>
                  // <Typography>BOOKING INFORMATION</Typography>
                  // </Badge>
                  "Survey Container"
                }
                value="1"
              /> */}

              <Tab
                sx={{
                  "&.Mui-selected": {
                    background: "#80C340",
                    color: "white",
                    borderTopLeftRadius: "15px",
                    borderTopRightRadius: "15px",
                  },
                }}
                label="Zone Container"
                value="2"
              />
              <Tab
                sx={{
                  "&.Mui-selected": {
                    background: "#80C340",
                    color: "white",
                    borderTopLeftRadius: "15px",
                    borderTopRightRadius: "15px",
                  },
                }}
                label="Plan Zone"
                value="3"
              />
            </TabList>
          </Box>
          <TabPanel value="1">
                <Survey/>
          </TabPanel>
          <TabPanel value="2"><Zone/></TabPanel>
          <TabPanel value="3"><PlanZone/></TabPanel>
        </TabContext>
      </Card>
    </LocalizationProvider>
  );
}
